import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { hasPermission } from 'utilities';
import BackrrLoadingAnimation from 'ui-components/route-components/BackrrLoadingAnimation';
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper';
import BreadcrumbHeader from 'layout/BreadcrumbsHeader';

/**
 * ProtectedRoute wrapper that checks user permissions before rendering a route
 * @param {React.Component} Component - The component to render if user has permission
 * @param {string} module - Permission module (e.g., 'performance', 'captable', 'pipeline')
 * @param {string} action - Permission action (e.g., 'view', 'edit', 'add')
 * @returns {React.Component} - Either the component, redirect, or loading state
 */
const ProtectedRoute = ({ Component, module, action = 'view' }) => {
  const userAccess = useSelector((state) => state?.permissions);

  if (!userAccess?.userPermissions) {
    return (
      <ThemeBGWrapper>
        <BreadcrumbHeader />
        <BackrrLoadingAnimation />
      </ThemeBGWrapper>
    );
  }

  if (!hasPermission(module, action, userAccess?.userPermissions)) {
    return <Navigate to="/profile" replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
